export default () => ({
    open: false,
    atStart: true,
    atEnd: false,

    init() {
        this.$nextTick(() => {
            this.updateCarouselBounds(this.$refs.featuredCarousel)
            this.$refs.featuredCarousel.addEventListener(
                'scroll',
                () => this.updateCarouselBounds(this.$refs.featuredCarousel),
                { passive: true }
            )
        })
    },

    toggle() {
        this.open = !this.open

        if (this.open) {
            this.$nextTick(() => {
                this.updateCarouselBounds(this.$refs.featuredCarousel)
            })
        }
    },

    updateCarouselBounds(el) {
        this.atStart = el.scrollLeft <= 0
        this.atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1
    },

    slideWidth() {
        const el = this.$refs.featuredCarousel
        const firstVisible = [...el.children].find(c => c.offsetWidth > 0)
        const gap = parseFloat(getComputedStyle(el).columnGap) || 0
        return (firstVisible?.offsetWidth ?? 208) + gap
    },

    scrollPrev() {
        const amount = this.slideWidth() * (this.atEnd ? 0.5 : 1)
        this.$refs.featuredCarousel.scrollBy({ left: -amount, behavior: 'smooth' })
    },

    scrollNext() {
        this.$refs.featuredCarousel.scrollBy({ left: this.slideWidth(), behavior: 'smooth' })
    },
})
